import { buildService as ogBuildService, RO } from '.';

const responseHooks: Function[] = [];

export const registerResponseHook = (hookFn: Function): any => {
  // console.log('registering a response hook++', hookFn);
  return responseHooks.push(hookFn);
};

const postResponse = (resp): Promise<any> => {
  // console.log('postResponse is being called++++', responseHooks);
  responseHooks.forEach(fn => fn());
  return resp;
};

// @TODO this should return a service and not any
export const buildService = (base: string, opts?: RO): any =>
  ogBuildService(base, { ...opts, postResponse });
